import { render, staticRenderFns } from "./edit_v1.vue?vue&type=template&id=13364d92"
import script from "./edit_v1.vue?vue&type=script&lang=js"
export * from "./edit_v1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports